import React, { useState } from 'react';

import Row from 'components/Common/Row';
import isoDateToAmerican from 'isoDateToAmerican';
import Button from 'kingpin/atoms/Button';
import Typography from 'kingpin/atoms/Typography';

import useFormatPaymentAmount from './useFormatPaymentAmount';
import usePaymentCreatorName from './usePaymentCreatorName';
import { getPaymentDisplay } from './utils';

// One recognition payment, with a two-step Remove.
const PaymentRow = ({
  payment,
  onRemove,
  isRemoving,
  isRemoveDisabled,
}: {
  payment: BonusTypes.AdditionalPayments.Payment;
  onRemove: (paymentId: string) => void;
  isRemoving: boolean;
  isRemoveDisabled: boolean;
}) => {
  const formatAmount = useFormatPaymentAmount();
  const [isConfirming, setIsConfirming] = useState(false);
  const createdBy = usePaymentCreatorName(payment);
  const { title, detail } = getPaymentDisplay(payment);

  return (
    <Row
      spaceBetween
      centerAlign
      style={{
        padding: '8px 0px',
        borderBottom: '1px solid var(--color-border-secondary)',
        gap: 8,
      }}
      data-testid={`additional-payment-${payment.id}`}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <Row centerAlign style={{ gap: 8 }}>
          <Typography.Body type={'Body 13 Bold'}>
            {formatAmount(payment.amount)}
          </Typography.Body>
          <Typography.Body type={'Body 13'}>{title}</Typography.Body>
        </Row>
        {detail && (
          <div>
            <Typography.Body type={'Body 12'}>{detail}</Typography.Body>
          </div>
        )}
        <Typography.Body type={'Body 12'} color={'var(--color-text-muted)'}>
          {`${createdBy ? `${createdBy} · ` : ''}${isoDateToAmerican(
            payment.createdOn,
          )}`}
        </Typography.Body>
      </div>
      {isConfirming ? (
        <Row centerAlign style={{ gap: 4 }}>
          <Button
            type={'Secondary'}
            size={'Small'}
            label={'Cancel'}
            onClick={() => setIsConfirming(false)}
            isDisabled={isRemoving}
          />
          <Button
            type={'Danger'}
            size={'Small'}
            label={'Remove'}
            onClick={() => onRemove(payment.id)}
            isLoading={isRemoving}
            testId={`confirm-remove-additional-payment-${payment.id}`}
          />
        </Row>
      ) : (
        <Button
          type={'Ghost'}
          size={'Small'}
          icon={'cross'}
          onClick={() => setIsConfirming(true)}
          isDisabled={isRemoveDisabled}
          testId={`remove-additional-payment-${payment.id}`}
        />
      )}
    </Row>
  );
};

export default PaymentRow;
